import { useQuery } from 'react-query';
import { http } from '../http';
import { Media } from 'types/Media';

export interface Profile {
  id?: string | null;
  name?: string | null;
  identifier?: string | null;
  avatar?: Media;
  displayName?: string;
}
async function getProfiles(): Promise<Array<Profile>> {
  return http.get<Array<Profile>>('/api/profiles', { responseType: 'json' }).then((response) => {
    return response.data;
  });
}

export function useQueryProfiles() {
  return useQuery(['profiles'], getProfiles, { staleTime: Infinity });
}
